import { Star } from "lucide-react";

export function ProductRating({ rating, reviews }) {
  return (
    <div className="mt-2 flex items-center gap-1.5 text-xs text-neutral-500">
      <Star size={14} className="fill-neutral-950 text-neutral-950" />
      <span className="font-medium text-neutral-800">{rating}</span>
      <span>({reviews})</span>
    </div>
  );
}